import { createActionCreator, Dispatch, ThunkActionCreator } from 'PyzShopUi/scripts/shop-ui/includes/enhanced-reducer';
import {
    IApiQueryData,
    IProductReviewActionState, IProductReviewItem, IProductReviewRatings, IProductReviewResponse, IStarItem
} from 'PyzShopUi/scripts/product-review/interfaces';
import { productReviewService } from 'PyzShopUi/scripts/product-review/services/ProductReviewService';
import { PARAM_SORT, PARAM_PAGE } from 'PyzShopUi/scripts/product-review/constants';

const UPDATE_PRODUCT_REVIEW_STATE = 'UPDATE_PRODUCT_REVIEW_STATE';
const BEGIN_PRODUCT_REVIEW_PAGE_LOADING = 'BEGIN_PRODUCT_REVIEW_PAGE_LOADING';
const END_PRODUCT_REVIEW_PAGE_LOADING = 'END_PRODUCT_REVIEW_PAGE_LOADING';

export const updateProductReviewState = createActionCreator<IProductReviewActionState>(UPDATE_PRODUCT_REVIEW_STATE);
export const beginGetProductReviewLoading = createActionCreator(BEGIN_PRODUCT_REVIEW_PAGE_LOADING);
export const endGetProductReviewLoading = createActionCreator(END_PRODUCT_REVIEW_PAGE_LOADING);

export const initProductReviewState: ThunkActionCreator<IProductReviewActionState> = (
    abstractSku: string
) => (dispatch, getState) => {
    productReviewService.setDefaultQueryObject({
        productAbstractSku: abstractSku,
    });

    const initState = getState();
    const apiQueryData: IApiQueryData = {
        ...initState.apiQueryData,
        ...productReviewService.getDefaultQueryObject()
    };

    doGetProductReviewData(dispatch, apiQueryData, []);
};

export const getProductReviewData: ThunkActionCreator<IProductReviewActionState> = (
    apiQueryData: IApiQueryData
) => (dispatch, getState) => {
    const { productReviews } = getState();

    doGetProductReviewData(dispatch, apiQueryData, productReviews);
};

const doGetProductReviewData = (dispatch: Dispatch, apiQueryData: IApiQueryData, productReviews: IProductReviewItem[]) => {
    dispatch(beginGetProductReviewLoading());
    productReviewService.getData(apiQueryData).then((data: IProductReviewResponse) => {
        const productReviewState = buildProductReviewState(data, apiQueryData, productReviews);
        dispatch(updateProductReviewState(productReviewState));
        dispatch(endGetProductReviewLoading());
    }).catch(() => {
        dispatch(endGetProductReviewLoading());
    });
}

const buildProductReviewState = (
    data: IProductReviewResponse,
    currentApiQueryData: IApiQueryData,
    productReviews: IProductReviewItem[]
): IProductReviewActionState => {
    const currentPage: number = data.pagination?.currentPage || 1;
    const currentSortParam: string = data.sort?.currentSortParam || null;
    const newFilterQueryParams = productReviewService.createQueryParams(data.filters);

    const apiQueryData: IApiQueryData = {
        ...currentApiQueryData,
        [PARAM_SORT]: currentSortParam,
        [PARAM_PAGE]: currentPage.toString(),
        ...newFilterQueryParams
    };

    const responseReviews: IProductReviewItem[] = [...productReviews, ...data.resultItems] ;

    return {
        productReviews: responseReviews,
        ratingStars: createRatingStars(data.productReviewRatings),
        pagination: data.pagination,
        sort: data.sort,
        filters: data.filters,
        isPageLoading: true,
        apiQueryData
    };
};

const createRatingStars = (productReviewRatings: IProductReviewRatings): IStarItem[] => {
    const starItems: IStarItem[] = [];
    for (const ratingKey in productReviewRatings) {
        starItems.push({
            averageRating: +ratingKey,
            reviewCount: productReviewRatings[ratingKey]
        });
    }

    return starItems;
};
